var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page9"},[_c('div',{staticClass:"wrapper"},[_c('Section1'),_c('Section2'),_c('Section3'),_c('Section')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }